import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useGetMiaRisorsaCalDav } from "./Services";

const CopyTextField: React.FC<{
  label: string;
  value: string;
  type?: string;
  onCopy: (value: string) => void;
  endAdornment?: React.ReactNode;
}> = ({ label, value, type = "text", onCopy, endAdornment }) => (
  <TextField
    label={label}
    value={value}
    type={type}
    fullWidth
    InputProps={{
      readOnly: true,
      endAdornment: (
        <InputAdornment position="end">
          {endAdornment}
          <IconButton edge="end" onClick={() => onCopy(value)} disabled={!value}>
            <ContentCopyIcon />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
);

const MioCalendarioCalDav: React.FC = () => {
  const { data, isLoading, isError, error } = useGetMiaRisorsaCalDav();
  const [showPassword, setShowPassword] = useState(false);
  const [snackbar, setSnackbar] = useState("");

  const copyValue = async (value: string) => {
    if (!value) return;
    await navigator.clipboard.writeText(value);
    setSnackbar("Copiato negli appunti");
  };

  const errorMessage =
    (error as any)?.response?.data?.message || "Configurazione calendario non disponibile";

  return (
    <Box sx={{ mt: "60px" }}>
      <Dialog open fullWidth maxWidth="md">
        <DialogTitle>
          <Typography variant="h5">Il Mio Calendario</Typography>
        </DialogTitle>
        <DialogContent>
          {isLoading && (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {isError && <Alert severity="warning">{errorMessage}</Alert>}

          {data && (
            <Stack spacing={2} sx={{ mt: 1 }}>
              <CopyTextField label="Risorsa" value={`${data.nomedip ?? ""} (${data.coddip ?? ""})`} onCopy={copyValue} />
              <CopyTextField label="URL CalDAV" value={data.caldavUrl ?? ""} onCopy={copyValue} />
              <CopyTextField label="Nome utente" value={data.username ?? ""} onCopy={copyValue} />
              <CopyTextField
                label="Password app"
                value={data.passwordApp ?? ""}
                type={showPassword ? "text" : "password"}
                onCopy={copyValue}
                endAdornment={
                  <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                }
              />
              {!data.enabled && <Alert severity="info">La sincronizzazione CalDAV risulta disabilitata.</Alert>}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button variant="contained" onClick={() => window.history.back()}>
                  CHIUDI
                </Button>
              </Box>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
      <Snackbar
        open={Boolean(snackbar)}
        autoHideDuration={2500}
        message={snackbar}
        onClose={() => setSnackbar("")}
      />
    </Box>
  );
};

export default MioCalendarioCalDav;
